import React from 'react'
import styles from './SlidesProgress.module.scss'
import Button from '@bt-react/components/Button'
import Icon, {IconType } from '@bt-react/components/Icon'
import classNames from 'classnames'

const resolveStageText = (stage) => {

  switch (stage) {

    case 'uploading':
      return 'Uploading file'
    case 'processing':
      return 'Checking and processing file'
    default:
      return 'Checking and processing file'

  }

}

const WarningMessage = () => <><Icon name={IconType.iconName.danger} colour={IconType.colour.task} /> Do not close this window until upload is complete</>

export const SlidesProgress = ({ stage, progress, onCancel }) => (
  <div className={styles['slides-progress-container']}>
    <div className={styles['slides-progress']}>
      <div className={classNames(styles['slides-progress-warning'], styles['heading-text-400'])}>{stage === 'uploading' && WarningMessage()}</div>
      <div className={styles['slides-progress-header']}>
        <div className={styles['slides-progress-stage']}>{resolveStageText(stage)}</div>
        {stage === 'uploading' && <Button
          dataBdd='cancel-button'
          onClick={onCancel}
          color={IconType.colour.link}
          text='Cancel'
        />}
      </div>
      <div className={styles['slides-progress-bar']}>
        <div style={{ width: `${progress}%` }}></div>
      </div>
      <div className={styles['slides-progress-percentage']}>{progress.toFixed(0)}%</div>
    </div>
  </div>
)
